import script from "./Borrower.vue?vue&type=script&setup=true&lang=ts"
export * from "./Borrower.vue?vue&type=script&setup=true&lang=ts"

import "./Borrower.vue?vue&type=style&index=0&id=5d875a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d875a86"]])

export default __exports__